module.exports = __webpack_public_path__ + "static/homeBannerIcon-ad220ffffa93ffd24e03f4eb9a53fd43.png";